import { Button } from '@/components/ui/button';
import clsx from 'clsx';
import { X } from 'lucide-react';
import { ComponentProps } from 'react';

export const TableFilterResetButton = ({
  className,
  show,
  label,
  ...other
}: ComponentProps<typeof Button> & { show?: boolean; label?: string }) => {
  return (
    show && (
      <Button variant="ghost" className={clsx('h-8 px-2 lg:px-3', className)} {...other}>
        {label ?? 'Reset filters'}
        <X className="ml-2 h-4 w-4" />
      </Button>
    )
  );
};
